import Rule from '../Rule'

export default class Comparison extends Rule {
  constructor ({
                 value,
                 customAttribute,
                 parameters
               }) {
    super({
      value,
      customAttribute
    })
    this.number = parameters
  }

  get valueType () {
    return Array.isArray(this.value) ? 'array' : typeof this.value
  }

  passesNumber () {
  }

  passesString () {
  }

  passesArray () {
  }

  passes () {
    switch (this.valueType) {
      case 'number':
        return this.passesNumber()
      case 'string':
        return this.passesString()
      case 'array':
        return this.passesArray()
      default:
        return false
    }
  }

  message () {
    return this.replaceMessage(super.message(this.valueType), 'number', this.number)
  }
}
